import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

export interface Team {
  team_id: string;
  team_alias?: string;
  members?: string[];
  spend?: number;
  max_budget?: number;
}

export function useTeams() {
  return useQuery({
    queryKey: ['teams'],
    queryFn: () => api<Team[]>('/api/teams'),
  });
}

export function useDeleteTeam() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (teamId: string) =>
      api('/api/teams/delete', { method: 'POST', body: { team_id: teamId } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['teams'] }),
  });
}
